import { ApiClient } from "@modules/core/api/client/apiClient"
import { ConfigService } from "@modules/core/services/configService"
import { TrainingApiGateway } from "@modules/training/services/trainingApi.gateway"
import { TrainingContentDto } from "@modules/training/services/trainingDto"
import { AvailableTrainingContentTypes } from "@modules/training/trainingTypes"
import { defaultDateFormat } from "@modules/utils/dateUtils"

import dayjs from "dayjs"
import _ from "lodash"

export class TrainingApi implements TrainingApiGateway {
  private baseUrl = "/trainings"

  constructor(private api: ApiClient) {}

  async getTrainingContents(startDate: string, endDate: string) {
    const result = await this.api.get<TrainingContentDto[]>(this.baseUrl, {
      params: {
        date: dayjs(startDate).format(defaultDateFormat),
        endDate: dayjs(endDate).format(defaultDateFormat),
      },
    })
    return result.data.filter((d: any) => AvailableTrainingContentTypes.includes(d.type))
    // .map((trainingContent: any) => convertTrainingContentFromDto(trainingContent))
  }

  async getTrainingContentDate(date: string) {
    const result = await this.api.get<TrainingContentDto[]>(
      `${ConfigService.config.BASE_URL.replace("/web", "")}/mobile${this.baseUrl}`,
      {
        params: {
          date: dayjs(date).format(defaultDateFormat),
        },
      },
    )
    return _.compact(
      result.data.filter((d) => AvailableTrainingContentTypes.includes(d.type)),
      // .map((trainingContent) => convertTrainingContentFromDto(trainingContent)),
    )
  }
}
